$(function(){
$(document).on('click','.u_filter_btn',function (e) {
      e.preventDefault();
    $(".u_filter_wrapper_block").addClass("u_filter_drawer_active");
    $('#ShopifyChat').addClass('u_chat_index')
    $("html").addClass("u_filter_overflow");
  });
    $(document).on('click','.u_filter_drawer_overlay,.u_filter_result_btn_sze,.u_filter_cross_block',function () {
    $(".u_filter_wrapper_block").removeClass("u_filter_drawer_active");
      $('#ShopifyChat').removeClass('u_chat_index')
    $("html").removeClass("u_filter_overflow");
  });
            $(document).on('click','.u_accordian_faq_head',function(){
                // self clicking
                // animation
                if($(this).next().hasClass('active'))
                {
                    $(this).next().removeClass('active').slideUp();
                    $(this).find('.u_faq_icon i').addClass('fa-angle-down').removeClass('fa-angle-up');
                 }
                else{
            $(this).next('.u_accordian_faq_body').addClass('active').slideDown();
            $(this).find('.u_faq_icon i').addClass('fa-angle-up').removeClass('fa-angle-down');
                }
            })
             $('.u_hamberger,.u_mb_menu_overlay,.u_mb_close_header').click(function(){
    $('.u_mobile_menu').toggleClass('active');
     $('#ShopifyChat').toggleClass('u_chat_index')
    $('.u_nav_ul_mb').toggle();
    $('.u_mb_menu_overlay').toggle();
    $('body').toggleClass('overflow');     
  });
  //   focus
  $('.fa_lighter').click(function(){
    $(this).parents('.u_input_search').find('.u_input_text').focus();

  });
  // mb_navigation responsive
  $('.u_navbar_item_link_mb').click(function(){
    $(this).find('.u_icon_mb').toggleClass('active_mb_icon');
    $(this).parent().parent().find('.u_sec_dropdown_mb,.u_third_dropdown_mb').slideToggle();
  })
    can_price();       
    console.log('length',$('.u_mb_custom_selected_filters_ul .custom-selected-filter-span-li').length);
    if($(".u_check_input:checked").length > 0 || $('.custom-selected-filter-span-li').length > 0 || $('.u_mb_custom_selected_filters_ul .custom-selected-filter-span-li').length > 0 || $('.custom-selected-filter-span-li-price').length> 0){
      $(".u_selected_filter_labels").attr("style", "display: flex;");
            $('.custom-clear-filters').show()
      $('.u_mb_custom_selected_filters').attr("style", "display: flex;");
    }
    $(".u_check_input:checked").each(function(){
      let ccc_title = "";
      if($(this).val().toLowerCase().trim() == '1'){
        ccc_title = ""; 
      }
      else if($(this).val().toLowerCase().trim() == '0'){
        ccc_title = "";
      }
      else{
    ccc_title = $(this).val();
      }
      $(".u_selected_filter_labels").append(`<li class="custom-selected-filter-span-li"><span class="custom-selected-filter-span"><em>${ccc_title}</em><i>&#10005;</i></span></li>`);
      $(".u_mb_custom_selected_filters_ul").append(`<li class="custom-selected-filter-span-li"><span class="custom-selected-filter-span"><i>&#10005;</i><em>${ccc_title}</em></span></li>`);
    });
  });

  $(document).on("change", ".u_check_input", function(){
   console.log('dwqedqw')
    ajax_req()
    
  });
  function ajax_req(){
    $(".u_selected_filter_labels").empty();
    $('.u_mb_custom_selected_filters_ul').empty();
    let symbol = $(".u_custom_filter_price").attr("symbol");
    let _price = $(".u_custom_filter_price");
    let l = location.href.toString();
    let min = parseInt(_price.attr("min-price"));
    let max = parseInt(_price.attr("max-price"));
    if(l.indexOf("filter.v.price.gte=") != -1){
      min = parseInt((l.split("filter.v.price.gte=")[1]).split("&")[0]);
      max = parseInt((l.split("filter.v.price.lte=")[1]).split("&")[0]);
    }
    let _priceFilter = _price.attr("min") + "=" + min + "&" + _price.attr("max") + "=" + max;
    let filterUrl = "";
    if($(".u_check_input:checked").length > 0 || $('.custom-selected-filter-span-li-price').length > 0 ||  $('.u_mb_custom_selected_filters_ul').length > 0){
      $(".u_selected_filter_labels").attr("style", "display: flex;");
      $('.custom-clear-filters').show()
      $(".u_mb_custom_selected_filters").attr("style", "display: flex;");
    }
    else{
      $(".u_selected_filter_labels").hide();
        $('.custom-clear-filters').hide()
    }
    $(".u_check_input:checked").each(function(){
      filterUrl += $(this).attr("name") + "=" + $(this).val() + "&";
      let ccc_title = "";
      if($(this).val().toLowerCase().trim() == '1'){
        ccc_title = ""; 
      }
      else if($(this).val().toLowerCase().trim() == '0'){
        ccc_title = "";
      }
      else{
        ccc_title = $(this).val();
      }
      console.log(ccc_title);
      $(".u_selected_filter_labels").append(`<li class="custom-selected-filter-span-li"><span class="custom-selected-filter-span"><em>${ccc_title}</em><i>&#10005;</i></span></li>`);
      $(".u_mb_custom_selected_filters_ul").append(`<li class="custom-selected-filter-span-li"><span class="custom-selected-filter-span"><i>&#10005;</i><em>${ccc_title}</em></span></li>`);
    });
     if(min > 1){
    $(".u_mb_selected_filter_price_labels").append('<li class="custom-selected-filter-span-li-price"><span class="custom_selected_filter_span_price"><em>' + symbol + " " + min+ " - " + symbol + "" + max +'</em><i>&#10005;</i></span></li>');
            $(".u_selected_filter_labels").append('<li class="custom-selected-filter-span-li-price"><span class="custom_selected_filter_span_price"><em>' + symbol + " " + min + " - " + symbol + "" + max +'</em><i>&#10005;</i></span></li>');
     }
    let final_url = $(".u_filter_labels").attr("data-url") + "?" + filterUrl + _priceFilter;
    console.log(final_url);
    $.ajax({
      type: "GET",
      url: final_url,
      dataType: "html",
      beforeSend: function(){
        $(".custom-filter-loader").show();
      },
      success: function(result){
        if($(result).find(".collection--body--grid .grid__item").length <= 0){
          console.log('0 products')
          //               $(".u_custom_msg").html(`<p class="custom-filter-loader-text">No Product Found!</p>`);
        }

        console.log('product length',$(result).find('.collection--body--grid .grid__item').length);
        $('.u_filter_result_count_no').html($(result).find('.u_filter_result_count_no').html())
        $(".collection--body--grid").html($(result).find(".collection--body--grid").html());
                $(".u_filter_label_append").html($(result).find(".u_filter_label_append").html());
        history.pushState({}, '', final_url);
      },
      complete: function(){
        window.dispatchEvent(new Event('resize'));
        $(".custom-filter-loader").hide();
        $(".u_filter_wrapper_block").removeClass("u_filter_drawer_active");
      $('#ShopifyChat').removeClass('u_chat_index')
    $("html").removeClass("u_filter_overflow");
      }
    });

  }
  $(function() {
    let l = location.href.toString();
    if(l.indexOf("filter.v.price.gte=") != -1){
      let min = parseInt((l.split("filter.v.price.gte=")[1]).split("&")[0]);
      let max = parseInt((l.split("filter.v.price.lte=")[1]).split("&")[0]);
      uiSlider(min, max);
    }
    else{
      uiSlider();
    }
  });

  function uiSlider(mn, mx){
    console.log(mx);
    let _max = 0;
    let _min = 0;
    let max = parseInt($(".u_custom_filter_price").attr("max-price"));
    let min = 0;
    if(mn == undefined && mx == undefined){
      _max = max;
      _min = min;
    }
    else{
      _max = mx;
      _min = mn;
    }
    let symbol = $(".u_custom_filter_price").attr("symbol");

    $(".u_custom_filter_price #slider").slider({
      range:true,
      min: min,
      max: max,
      values: [_min, _max],
      slide: function(event, ui) {
        $("#slider .u_left_ui_price").text(symbol + "" + ui.values[0]);
        $("#slider .u_right_ui_price").text(symbol + "" + ui.values[1]);

      }, 
      stop: function(event, ui){
        let _price = $(".u_custom_filter_price");
        let _priceFilter = _price.attr("min") + "=" + ui.values[0] + "&" + _price.attr("max") + "=" + ui.values[1];
        let filterUrl = "";
        $(".u_check_input:checked").each(function(){
          filterUrl += $(this).attr("name") + "=" + $(this).val() + "&";
        });
        let final_url = $(".u_filter_labels").attr("data-url") + "?" + filterUrl + _priceFilter;
        console.log('url',final_url);
        $.ajax({
          type: "GET",
          url: final_url,
          dataType: "html",
          beforeSend: function(){
        $(".custom-filter-loader").show();
          },
          success: function(result){
                                    $(".u_mb_selected_filter_price_labels").html('<li class="custom-selected-filter-span-li-price"><span class="custom_selected_filter_span_price"><i>&#10005;</i><em>' + symbol + " " + ui.values[0]+ " - " + symbol + "" + ui.values[1]+'</em></span></li>');
            $(".u_selected_filter_price_labels").html('<li class="custom-selected-filter-span-li-price"><span class="custom_selected_filter_span_price"><i>&#10005;</i><em>' + symbol + " " + ui.values[0]+ " - " + symbol + "" + ui.values[1]+'</em></span></li>');
            if($(".u_check_input:checked").length > 0 || $('.custom-selected-filter-span-li-price').length > 0){
              $(".u_selected_filter_labels").attr("style", "display: flex;");
              $(".u_mb_custom_selected_filters").attr("style", "display: flex;");
            }
           console.log('product length',$(result).find('.collection--body--grid .grid__item').length);
           $('.u_filter_result_count_no').html($(result).find('.u_filter_result_count_no').html())
        $(".collection--body--grid").html($(result).find(".collection--body--grid").html());
                $(".u_filter_labels").html($(result).find(".u_filter_labels").html());
            if($(result).find(".product--root").length <= 0){
              console.log($(result).find('.product--root').length);
              console.log('no product');
              //               $(".u_custom_msg").append(`<p class="custom-filter-loader-text">No Product Found!</p>`);
            }

            history.pushState({}, '', final_url);
          },
          complete: function(){
            window.dispatchEvent(new Event('resize'));
            if(final_url.indexOf("filter.v.price.gte=") != -1){
              let newMin = parseInt((final_url.split("filter.v.price.gte=")[1]).split("&")[0]);
              let newMax = parseInt((final_url.split("filter.v.price.lte=")[1]).split("&")[0]);
              uiSlider(newMin, newMax);
            }
        $(".custom-filter-loader").hide();
          }
        });
      }
    });
    $("#slider span:nth-child(2)").html('<p class="u_left_ui_price">'+symbol+ ""+$("#slider").slider("values", 0)+'</p>');
    $("#slider span:last-child").html('<p class="u_right_ui_price">'+symbol+ ""+$("#slider").slider("values", 1) + '</p>');
  }
  $(document).on("click", ".custom-selected-filter-span", function(){
    console.log('dd');
    let title = $(this).find("em").text().toLowerCase().trim();
    $(".u_filter_span").each(function(){
      if($(this).attr('filter_val').toLowerCase().trim() == title){
        $(this).parent().find('.u_check_input').prop('checked', false); // Unchecks it
      }
    });
    $(this).parent().hide();
    ajax_req();
    console.log('length',$('.u_mb_custom_selected_filters_ul .custom-selected-filter-span-li').length);
    if($(".u_check_input:checked").length > 0 || $('.custom-selected-filter-span-li-price').length > 0 ||  $('.u_mb_custom_selected_filters_ul .custom-selected-filter-span-li').length > 0){
      $(".u_selected_filter_labels").attr("style", "display: flex;");
      $(".u_mb_custom_selected_filters").attr("style", "display: flex;");
        $('.custom-clear-filters').show()
    }
    else{
      $(".u_selected_filter_labels").hide();
      $(".u_mb_custom_selected_filters").hide();
        $('.custom-clear-filters').hide()
    }
  });
  $(document).on("click", ".u_clear_filters,.custom-clear-filters", function(){

    let f_url = $(".u_filter_labels").attr("data-url");
    $(".custom-selected-filters-li").empty();
    $(".custom-selected-filters-ul").hide();
      $('.custom-clear-filters').hide()
    $.ajax({
      type: "GET",
      url: f_url,
      dataType: "html",
      beforeSend: function(){
        $(".custom-filter-loader").show();
      },
      success: function(result){
        if($(result).find(".product--root").length <= 0){
          //               $(".u_custom_msg").html(`<p class="custom-filter-loader-text">No Product Found!</p>`);
        }     
         console.log('product length',$(result).find('.collection--body--grid .grid__item').length);
         $('.u_filter_result_count_no').html($(result).find('.u_filter_result_count_no').html())
        $(".collection--body--grid").html($(result).find(".collection--body--grid").html());
                $(".u_filter_labels").html($(result).find(".u_filter_labels").html());
        history.pushState({}, '', f_url);
      },
      complete: function(){
        window.dispatchEvent(new Event('resize'));
        $(".custom-filter-loader").hide();
        let gte = parseInt($(".u_custom_filter_price").attr("max-price"));
        let lte = 0;
        uiSlider(lte, gte);
$(".u_filter_wrapper_block").removeClass("u_filter_drawer_active");
      $('#ShopifyChat').removeClass('u_chat_index')
    $("html").removeClass("u_filter_overflow");
      }
    });
  });
  $(document).on('click','.custom_selected_filter_span_price',function(){
    console.log('price selected');
      $(".u_selected_filter_labels").empty();
    let max = parseInt($(".u_custom_filter_price").attr("max-price"));
    let min = 0;
    let _price = $(".u_custom_filter_price");
    let _priceFilter = _price.attr("min") + "=" + min + "&" + _price.attr("max") + "=" + max;
    let filterUrl = "";
   $(".u_check_input:checked").each(function(){
      filterUrl += $(this).attr("name") + "=" + $(this).val() + "&";
      let ccc_title = "";
      if($(this).val().toLowerCase().trim() == '1'){
        ccc_title = ""; 
      }
      else if($(this).val().toLowerCase().trim() == '0'){
        ccc_title = "";
      }
      else{
        ccc_title = $(this).val();
      }
      console.log(ccc_title);
      $(".u_selected_filter_labels").append(`<li class="custom-selected-filter-span-li"><span class="custom-selected-filter-span"><em>${ccc_title}</em><i>&#10005;</i></span></li>`);
      $(".u_mb_custom_selected_filters_ul").append(`<li class="custom-selected-filter-span-li"><span class="custom-selected-filter-span"><i>&#10005;</i><em>${ccc_title}</em></span></li>`);
    });
    let final_url = $(".u_filter_labels").attr("data-url") + "?" + filterUrl + _priceFilter;
    console.log('url',final_url);
    $.ajax({
      type: "GET",
      url: final_url,
      dataType: "html",
      beforeSend: function(){
        $(".custom-filter-loader").show();
      },
      success: function(result){
      
          $('.u_filter_result_count_no').html($(result).find('.u_filter_result_count_no').html())
        $(".collection--body--grid").html($(result).find(".collection--body--grid").html());
                $(".u_filter_label_append").html($(result).find(".u_filter_label_append").html());
         $(".u_mb_selected_filter_price_labels").empty();
      if($(".u_check_input:checked").length > 0 || $('.custom-selected-filter-span-li').length > 0 || $('.u_mb_custom_selected_filters_ul .custom-selected-filter-span-li').length > 0 || $('.u_mb_selected_filter_price_labels .custom-selected-filter-span-li-price').length> 0){
      $(".u_selected_filter_labels").attr("style", "display: flex;");
      $('.u_mb_custom_selected_filters').attr("style", "display: flex;");
       $('.custom-clear-filters').show()
    }
      else{
      $(".u_selected_filter_labels").hide();
      $(".u_mb_custom_selected_filters").hide();
             $('.custom-clear-filters').hide()
    }   
    
        if($(result).find(".product--root").length <= 0){
          console.log($(result).find('.product--root').length);
          console.log('no product');
          //               $(".u_custom_msg").append(`<p class="custom-filter-loader-text">No Product Found!</p>`);
        }

        history.pushState({}, '', final_url);
      },
      complete: function(){
        window.dispatchEvent(new Event('resize'));
        if(final_url.indexOf("filter.v.price.gte=") != -1){
          let newMin = parseInt((final_url.split("filter.v.price.gte=")[1]).split("&")[0]);
          let newMax = parseInt((final_url.split("filter.v.price.lte=")[1]).split("&")[0]);
          uiSlider(newMin, newMax);
        }
        $(".custom-filter-loader").hide();
        $(".u_filter_wrapper_block").removeClass("u_filter_drawer_active");
      $('#ShopifyChat').removeClass('u_chat_index')
    $("html").removeClass("u_filter_overflow");
      }
    });
  })

  function can_price(){
    let can_url =location.href;
    console.log('price url',can_url)
    if(can_url.indexOf("filter.v.price.gte=") != -1 || can_url.indexOf("filter.v.price.lte=") != -1){
      let split_url_gte =can_url.split("filter.v.price.gte=");
      let split_again=split_url_gte[1].split('&');
      let gte_pri = split_again[0];
      let split_url_lte =can_url.split("filter.v.price.lte=");
      let lte_pri = split_url_lte[1].slice(0);
      console.log('gte price',gte_pri,'lte price',lte_pri)
      let symbol = $(".u_custom_filter_price").attr("symbol");
      console.log('gte ',gte_pri)
      if(gte_pri == 0){
        $(".u_selected_filter_labels").empty();
        $(".u_mb_selected_filter_price_labels").empty();

      }
      else{
        $(".u_selected_filter_labels").html(`<li class="custom-selected-filter-span-li-price"><span class="custom_selected_filter_span_price"><em>${symbol} ${gte_pri} - ${symbol} ${lte_pri}</em><i>&#10005;</i></span></li>`);
                $(".u_mb_selected_filter_price_labels").html(`<li class="custom-selected-filter-span-li-price"><span class="custom_selected_filter_span_price"><em>${symbol} ${gte_pri} - ${symbol} ${lte_pri}</em><i>&#10005;</i></span></li>`);
      }
    }
  }
  $(document).on("click", ".u-custom-clear-filters", function(){

    let f_url = $(".u_filter_labels").attr("data-url");
    $(".custom-selected-filters-li").empty();
    $(".custom-selected-filters-ul").hide();
    $.ajax({
      type: "GET",
      url: f_url,
      dataType: "html",
      beforeSend: function(){
        $(".custom-filter-loader").show();
      },
      success: function(result){
        if($(result).find(".product--root").length <= 0){
          //               $(".u_custom_msg").html(`<p class="custom-filter-loader-text">No Product Found!</p>`);
        }     
        console.log($(result).find('.product--root').length);
        $(".collection--body--grid").html($(result).find(".collection--body--grid").html());
        $(".u_filter_content").html($(result).find(".u_filter_content").html());
        $('.u_mb_filter_parent').html($(result).find(".u_mb_filter_parent").html())
        history.pushState({}, '', f_url);
      },
      complete: function(){
        window.dispatchEvent(new Event('resize'));
        $(".custom-filter-loader").hide();
        let gte = parseInt($(".u_custom_filter_price").attr("max-price"));
       $(".u_filter_wrapper_block").removeClass("u_filter_drawer_active");
      $('#ShopifyChat').removeClass('u_chat_index')
    $("html").removeClass("u_filter_overflow");
      }
    });
})
     $(document).on("change", ".u_price_check_input", function(){
      console.log('click')
    $(".u_selected_filter_labels").empty();
    $('.u_mb_custom_selected_filters_ul').empty();
    let min = parseInt($(this).attr("min-price"));
    let max = parseInt($(this).attr("max-price"));
    let _priceFilter = $(this).attr("min") + "=" + min + "&" + $(this).attr("max") + "=" + max;
    let filterUrl = "";
    if($(".u_check_input:checked").length > 0 || $('.custom-selected-filter-span-li-price').length > 0 ||  $('.u_mb_custom_selected_filters_ul').length > 0){
      $(".u_selected_filter_labels").attr("style", "display: flex;");
      $('.custom-clear-filters').show()
      $(".u_mb_custom_selected_filters").attr("style", "display: flex;");
    }
    else{
      $(".u_selected_filter_labels").hide();
        $('.custom-clear-filters').hide()
    }
    $(".u_check_input:checked").each(function(){
      filterUrl += $(this).attr("name") + "=" + $(this).val() + "&";
      let ccc_title = "";
      if($(this).val().toLowerCase().trim() == '1'){
        ccc_title = ""; 
      }
      else if($(this).val().toLowerCase().trim() == '0'){
        ccc_title = "";
      }
      else{
        ccc_title = $(this).val();
      }
      console.log(ccc_title);
      $(".u_selected_filter_labels").append(`<li class="custom-selected-filter-span-li"><span class="custom-selected-filter-span"><em>${ccc_title}</em><i>&#10005;</i></span></li>`);
      $(".u_mb_custom_selected_filters_ul").append(`<li class="custom-selected-filter-span-li"><span class="custom-selected-filter-span"><i>&#10005;</i><em>${ccc_title}</em></span></li>`);

    });
    let final_url = $(".u_filter_labels").attr("data-url") + "?" + filterUrl + _priceFilter;
    console.log(final_url);
      let symbol = $(".u_custom_filter_price").attr("symbol");
     $.ajax({
      type: "GET",
      url: final_url,
      dataType: "html",
      beforeSend: function(){
        $(".custom-filter-loader").show();
      },
      success: function(result){
        if($(result).find(".collection--body--grid .grid__item").length <= 0){
          console.log('0 products')
          //               $(".u_custom_msg").html(`<p class="custom-filter-loader-text">No Product Found!</p>`);
        }
$(".u_mb_selected_filter_price_labels").append('<li class="custom-selected-filter-span-li-price"><span class="custom_selected_filter_span_price"><em>' + symbol + " " + min+ " - " + symbol + "" + max +'</em><i>&#10005;</i></span></li>');
            $(".u_selected_filter_labels").append('<li class="custom-selected-filter-span-li-price"><span class="custom_selected_filter_span_price"><em>' + symbol + " " + min + " - " + symbol + "" + max +'</em><i>&#10005;</i></span></li>');
            if($(".u_check_input:checked").length > 0 || $('.custom-selected-filter-span-li-price').length > 0){
              $(".u_selected_filter_labels").attr("style", "display: flex;");
              $('.custom-clear-filters').show()
              $(".u_mb_custom_selected_filters").attr("style", "display: flex;");
            }
        console.log('product length',$(result).find('.u_filter_result_count_no').html().trim());
        $('.u_filter_result_count_no').html($(result).find('.u_filter_result_count_no').html())
        $(".collection--body--grid").html($(result).find(".collection--body--grid").html());
                $(".u_filter_label_append").html($(result).find(".u_filter_label_append").html());
        history.pushState({}, '', final_url);
      },
      complete: function(){
        window.dispatchEvent(new Event('resize'));
        $(".custom-filter-loader").hide();
        $(".u_filter_wrapper_block").removeClass("u_filter_drawer_active");
      $('#ShopifyChat').removeClass('u_chat_index')
    $("html").removeClass("u_filter_overflow");
      }
    });
  })